import React from 'react';
import { formatCurrencyNumber } from '../../../Common/format';

const DebtTableRow = ({ description, title, type, amount, barcode }) => (
    <tr>
        <td>
            <span className="d-block">{title}</span>
            <small>{barcode}</small>
            <small>{description}</small>
        </td>
        <td className="text-right text-nowrap">R$ {formatCurrencyNumber(amount)}</td>
    </tr>
);

export default DebtTableRow;



// WEBPACK FOOTER //
// ./src/components/Pages/Receipt/DebtTableRow.js